import logoDark from "../assets/logo-main-light.svg";
import logoLight from "../assets/logo-dark.svg";
import markDark from "../assets/logo-mark-dark.svg";
import markLight from "../assets/logo-mark-light.svg";
import { useTheme } from "./ThemeContext";

export function useThemedLogo() {
  const { isDark } = useTheme();
  return isDark ? logoDark : logoLight;
}

export function useThemedLogoMark() {
  const { isDark } = useTheme();
  return isDark ? markLight : markDark;
}
